<app-loader></app-loader>

<div class="main-bg relative w-full h-screen min-h-[100vh] bg-cover bg-center overflow-y-auto">
  <!-- Main Container with Left and Right Divs -->
  <div class="flex-1 flex flex-col lg:flex-row lg:absolute lg:inset-0">
    <!-- LeftDiv: Logo, Welcome Text, Person Image -->
    <div class="lg:flex flex-1 flex-col justify-between ml-1">
      <!-- 1. Logo -->
      <div class="hidden md:hidden lg:flex justify-start lg:mb-0 pt-4 lg:p-[2.5rem]">
        <img src="https://cmax-banners.pages.dev/assets/hr-logo.png" alt="Logo" class="w-[170px] h-[116px]" />

      </div>
      <!-- Welcome Text -->
      <div
        class="mobile-welcome-text flex flex-col items-start text-left text-white max-w-xl md:mb:0 sm:mb:0 mx-auto lg:mx-0 pl-[3rem] lg:flex">
        <h1 class="text-2xl xl:text-4xl 2xl:text-6xl font-bold mb-4 leading-tight">
          Reset Your <span class="text-cyan-400">Password</span>
        </h1>
        <p class="text-gray-300 text-base xl:text-lg leading-relaxed">
          Create a new secure password to regain access to your account and
          continue enjoying your entertainment journey.
        </p>
      </div>
      <!-- 3. Person Image -->
      <div class="hidden lg:flex justify-start items-end">
        <!-- <img src="https://cmax.pages.dev/assets/Person.png" alt="Person" class="w-40 lg:w-56 2xl:w-[18rem] xl:w-[13rem] h-auto" /> -->
         <div class="w-40 lg:w-56 2xl:w-[18rem] xl:w-[13rem] h-auto"></div>
      </div>
    </div>
    <!-- RightDiv: Form Section -->
    <div class="flex-1 flex items-start lg:items-center justify-center p-4 lg:p-8 lg:pr-16 pb-20 lg:pb-8">
      <div
        class="bg-white bg-opacity-20 lg:backdrop-blur-[1px] md:backdrop-blur-md rounded-[1.5rem] p-4 sm:p-5 md:p-6 lg:p-8 2xl:p-[3rem] w-full max-w-sm sm:max-w-sm md:max-w-md 2xl:max-w-[30rem] mx-auto lg:mx-0 shadow-2xl lg:max-h-[90vh] lg:overflow-y-auto"
        id="formContainer">
        <!-- Header -->
        <div class="mb-6 lg:mb-4">
          <div class="flex items-center gap-2 mb-3 lg:mb-2">
            <span class="text-[#7DE7E5] text-lg lg:text-[24px] font-semibold">Change Password</span>
          </div>
          <p class="text-white text-sm lg:text-[1.2rem] mb-2 lg:mb-10 xl:mb-12">
            Enter your new password details
          </p>
        </div>
        <!-- Form -->
        <form [formGroup]="changePasswordForm" (ngSubmit)="onSubmit()">
          <!-- New Password -->
          <div class="mb-5">
            <div class="relative">
              <input [type]="passwordVisibility['newPassword'] ? 'text' : 'password'" id="newPassword"
                formControlName="newPassword" placeholder="Enter new password" required
                class="w-full text-white placeholder-white border-b border-white py-3 focus:border-b-2 focus:border-[#7DE7E5] transition-colors focus:outline-none peer bg-inherit text-sm" />
              <div class="absolute right-11 top-1/2 transform -translate-y-1/2">
                <fa-icon [icon]="passwordVisibility['newPassword'] ? eye : eyeSlash"
                  (click)="toggleVisibility('newPassword')"
                  class="cursor-pointer text-white hover:text-[#7DE7E5] transition-colors text-xs"></fa-icon>
              </div>
              <span class="absolute right-9 top-1/2 text-white transform -translate-y-1/2">|</span>
              <span>
                <i class="fas fa-lock text-white absolute right-3 top-1/2 transform -translate-y-1/2"></i>
              </span>
            </div>
          </div>
          <!-- Confirm Password -->
          <div class="mb-5">
            <div class="relative">
              <input [type]="
                  passwordVisibility['confirmPassword'] ? 'text' : 'password'
                " id="confirmPassword" formControlName="confirmPassword" placeholder="Confirm new password" required
                class="w-full text-white placeholder-white border-b border-white py-3 focus:border-b-2 focus:border-[#7DE7E5] transition-colors focus:outline-none peer bg-inherit text-sm" />
              <div class="absolute right-11 top-1/2 transform -translate-y-1/2">
                <fa-icon [icon]="
                    passwordVisibility['confirmPassword'] ? eye : eyeSlash
                  " (click)="toggleVisibility('confirmPassword')"
                  class="cursor-pointer text-white hover:text-[#7DE7E5] transition-colors text-xs"></fa-icon>
              </div>
              <span class="absolute right-9 top-1/2 text-white transform -translate-y-1/2">|</span>
              <span>
                <i class="fas fa-lock text-white absolute right-3 top-1/2 transform -translate-y-1/2"></i>
              </span>
            </div>
          </div>
          <!-- Password Guidelines -->
          <div class="mb-5 p-2 bg-black bg-opacity-20 rounded">
            <ul class="space-y-1 text-xs">
              <li class="flex items-center gap-2" [class.text-green-500]="validateGuidelines('length')"
                [class.text-red-500]="!validateGuidelines('length')">
                <input type="checkbox" id="lengthCheck" [checked]="validateGuidelines('length')" disabled
                  class="mr-1" />
                Password Length should be greater than 8.
              </li>
              <li class="flex items-center gap-2" [class.text-green-500]="validateGuidelines('digit')"
                [class.text-red-500]="!validateGuidelines('digit')">
                <input type="checkbox" id="digitCheck" [checked]="validateGuidelines('digit')" disabled class="mr-1" />
                Minimum 1 Number in the password.
              </li>
              <li class="flex items-center gap-2" [class.text-green-500]="validateGuidelines('uppercase')"
                [class.text-red-500]="!validateGuidelines('uppercase')">
                <input type="checkbox" id="uppercaseCheck" [checked]="validateGuidelines('uppercase')" disabled
                  class="mr-1" />
                Minimum 1 capital letter in the password.
              </li>
              <li class="flex items-center gap-2" [class.text-green-500]="validateGuidelines('specialChar')"
                [class.text-red-500]="!validateGuidelines('specialChar')">
                <input type="checkbox" id="specialCharCheck" [checked]="validateGuidelines('specialChar')" disabled
                  class="mr-1" />
                Minimum 1 special character in the password like &#64;, &#35;,
                &#36;.
              </li>
              <li class="flex items-center gap-2" [class.text-green-500]="validateGuidelines('match')"
                [class.text-red-500]="!validateGuidelines('match')">
                <input type="checkbox" id="matchCheck" [checked]="validateGuidelines('match')" disabled class="mr-1" />
                Password should match with confirm password.
              </li>
            </ul>
          </div>
          <!-- Change Password Button -->
          <button type="submit" [disabled]="changePasswordForm.invalid"
            class="w-full mb-5 --button px-1 py-[0.55rem] font-semibold rounded-[0.45rem] transition-all duration-300 ease-in-out disabled:opacity-50 disabled:cursor-not-allowed transform hover:scale-105 text-base">
            Set Password
          </button>
        </form>
      </div>
    </div>
  </div>
  <!-- Bottom Character Image - Mobile Only -->
  <div class="lg:hidden flex justify-start items-end fixed bottom-0 left-0 right-0 pl-2">
    <!-- <img src="https://cmax.pages.dev/assets/Person.png" alt="Character" class="w-[7rem] sm:w-[8rem] h-auto" /> -->
  </div>
</div>
<!--
<div
  class="flex flex-col md:flex-row justify-between items-center w-full max-w-3xl mx-auto p-6 bg-white bg-opacity-20 shadow-lg backdrop-blur-md rounded-lg mt-12"
>
  <div class="w-full md:w-1/2 p-4">
    <h2 class="text-2xl font-bold text-white mb-6 border-b-2 border-white pb-2">
      Change Password
    </h2>
    <form [formGroup]="changePasswordForm" (ngSubmit)="onSubmit()">
      <div class="mb-4 relative">
        <label for="newPassword" class="block text-white text-sm mb-2"
          >New Password</label
        >
        <div class="relative">
          <input
            [type]="passwordVisibility['newPassword'] ? 'text' : 'password'"
            id="newPassword"
            formControlName="newPassword"
            placeholder="Enter new password"
            required
            class="w-full p-3 bg-white bg-opacity-10 border border-gray-300 rounded-lg text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-purple-500"
          />
          <fa-icon
            [icon]="passwordVisibility['newPassword'] ? eye : eyeSlash"
            (click)="toggleVisibility('newPassword')"
            class="absolute right-3 top-3 cursor-pointer text-white"
          ></fa-icon>
        </div>
      </div>

      <div class="mb-4 relative">
        <label for="confirmPassword" class="block text-white text-sm mb-2"
          >Confirm Password</label
        >
        <div class="relative">
          <input
            [type]="passwordVisibility['confirmPassword'] ? 'text' : 'password'"
            id="confirmPassword"
            formControlName="confirmPassword"
            placeholder="Confirm new password"
            required
            class="w-full p-3 bg-white bg-opacity-10 border border-gray-300 rounded-lg text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-purple-500"
          />
          <fa-icon
            [icon]="passwordVisibility['confirmPassword'] ? eye : eyeSlash"
            (click)="toggleVisibility('confirmPassword')"
            class="absolute right-3 top-3 cursor-pointer text-white"
          ></fa-icon>
        </div>
      </div>

      <button
        type="submit"
        [disabled]="changePasswordForm.invalid"
        [ngClass]="{
          'cursor-not-allowed': changePasswordForm.invalid,
          'cursor-pointer': !changePasswordForm.invalid
        }"
        class="w-full p-3 bg-gradient-to-r from-purple-600 to-blue-600 text-white rounded-lg hover:bg-purple-700 transition duration-300"
      >
        Set Password
      </button>
    </form>
  </div>

  <div class="w-full md:w-1/2 p-4 text-white">
    <ul class="space-y-2">
      <li
        class="flex items-center"
        [ngClass]="{
          'text-red-500': !validateGuidelines('length'),
          'text-green-500': validateGuidelines('length')
        }"
      >
        <input
          type="checkbox"
          id="lengthCheck"
          [checked]="validateGuidelines('length')"
          disabled
          class="mr-2"
        />
        Password Length should be greater than 8.
      </li>
      <li
        class="flex items-center"
        [ngClass]="{
          'text-red-500': !validateGuidelines('digit'),
          'text-green-500': validateGuidelines('digit')
        }"
      >
        <input
          type="checkbox"
          id="digitCheck"
          [checked]="validateGuidelines('digit')"
          disabled
          class="mr-2"
        />
        Minimum 1 Number in the password.
      </li>
      <li
        class="flex items-center"
        [ngClass]="{
          'text-red-500': !validateGuidelines('uppercase'),
          'text-green-500': validateGuidelines('uppercase')
        }"
      >
        <input
          type="checkbox"
          id="uppercaseCheck"
          [checked]="validateGuidelines('uppercase')"
          disabled
          class="mr-2"
        />
        Minimum 1 capital letter in the password.
      </li>
      <li
        class="flex items-center"
        [ngClass]="{
          'text-red-500': !validateGuidelines('specialChar'),
          'text-green-500': validateGuidelines('specialChar')
        }"
      >
        <input
          type="checkbox"
          id="specialCharCheck"
          [checked]="validateGuidelines('specialChar')"
          disabled
          class="mr-2"
        />
        Minimum 1 special character in the password like &#64;, &#35;, &#36;.
      </li>
      <li
        class="flex items-center"
        [ngClass]="{
          'text-red-500': !validateGuidelines('match'),
          'text-green-500': validateGuidelines('match')
        }"
      >
        <input
          type="checkbox"
          id="matchCheck"
          [checked]="validateGuidelines('match')"
          disabled
          class="mr-2"
        />
        Password should match with confirm password.
      </li>
    </ul>
  </div>
</div> -->
